import { Group, Stack, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { RecordLabel } from '../Diff/RecordLabel.js';
import { ENTITY_TYPES } from '../../domain/entityTypes.js';
import type { DeleteMasterArgs } from '../../hooks/useDeleteMaster.js';

/** Spells out the irreversible scope, then runs `onConfirm`. */
export const confirmDeleteMaster = (args: DeleteMasterArgs, onConfirm: () => void) => {
    const scope = ENTITY_TYPES[args.type].deleteScope(args.childCount);
    modals.openConfirmModal({
        title: (
            <Group gap={6} wrap="wrap">
                <Text fw={600}>Delete</Text>
                <RecordLabel title={args.title} entityKey={args.key} layout="inline" size="sm" />
                <Text fw={600}>from master?</Text>
            </Group>
        ),
        size: 'min(520px, 100%)',
        children: (
            <Stack gap="sm">
                <Text size="sm">{scope}</Text>
                <Text size="sm" fw={600}>
                    No environment records will be deleted.
                </Text>
                <Text fz="xs" c="dimmed">
                    After the next pull, matching environment records will appear as Env only and can be adopted into
                    master again.
                </Text>
            </Stack>
        ),
        labels: { confirm: 'Delete master', cancel: 'Cancel' },
        confirmProps: { color: 'red' },
        onConfirm,
    });
};
